/* eslint-disable no-invalid-this */
/* eslint-disable func-style */
export function arraizeIconsCategory(library) {
  return (() => {
    const list = Object.keys(library)
    if (this.state.searched) {
      return list.filter((value) => value.includes(this.state.searched))
    }
    return list
  })().map((key) => ({
    key,
    value: library[key]
  }))
}
